import ManageLoans from 'features/payOverTime/screens/ManageLoans/ManageLoans';
import React from 'react';

export default function Page() {
  return <ManageLoans />;
}
